import apiBase from "../../api/axios";

export const getPreguntasConfirmacionService = async (page = 1, search = "") => {
  let url = `v1/talentos-global/preguntas-confirmacion/?page=${page}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getPreguntaConfirmacionByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/preguntas-confirmacion/${id}/`);
  return response.data;
};

export const updatePreguntaConfirmacionService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/preguntas-confirmacion/${id}/`, payload);
  return response.data;
};

export const togglePreguntaConfirmacionActiveService = async (id) => {
  const response = await apiBase.patch(`v1/talentos-global/preguntas-confirmacion/${id}/toggle-status/`);
  return response.data;
};

export const getPreguntasSelectoresService = async (search = "") => {
  let url = "v1/talentos-global/selectores/preguntas-confirmacion/";
  if (search) {
    url += `?search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};
